(function () {
  'use strict';

  var MEDIA_SAMPLE_SIZE = 96;

  function median(values) {
    values.sort(function (a, b) { return a - b; });
    return values[Math.floor(values.length / 2)] || 0;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function getImagePixels(image) {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d', { willReadFrequently: true });
    canvas.width = MEDIA_SAMPLE_SIZE;
    canvas.height = MEDIA_SAMPLE_SIZE;
    context.drawImage(image, 0, 0, MEDIA_SAMPLE_SIZE, MEDIA_SAMPLE_SIZE);
    return context.getImageData(0, 0, MEDIA_SAMPLE_SIZE, MEDIA_SAMPLE_SIZE).data;
  }

  function sampleBackground(pixels) {
    var red = [];
    var green = [];
    var blue = [];
    var size = MEDIA_SAMPLE_SIZE;

    function sample(x, y) {
      var offset = (y * size + x) * 4;
      if (pixels[offset + 3] < 220) return;
      red.push(pixels[offset]);
      green.push(pixels[offset + 1]);
      blue.push(pixels[offset + 2]);
    }

    for (var index = 0; index < size; index += 1) {
      sample(index, 0);
      sample(index, 1);
      sample(index, size - 2);
      sample(index, size - 1);
      sample(0, index);
      sample(1, index);
      sample(size - 2, index);
      sample(size - 1, index);
    }

    return [median(red), median(green), median(blue)];
  }

  function subjectBounds(pixels, background) {
    var size = MEDIA_SAMPLE_SIZE;
    var columns = new Array(size).fill(0);
    var rows = new Array(size).fill(0);
    var threshold = 34 * 34;

    for (var y = 1; y < size - 1; y += 1) {
      for (var x = 1; x < size - 1; x += 1) {
        var offset = (y * size + x) * 4;
        if (pixels[offset + 3] < 220) continue;
        var red = pixels[offset] - background[0];
        var green = pixels[offset + 1] - background[1];
        var blue = pixels[offset + 2] - background[2];
        if ((red * red) + (green * green) + (blue * blue) > threshold) {
          columns[x] += 1;
          rows[y] += 1;
        }
      }
    }

    var activeColumns = [];
    var activeRows = [];
    columns.forEach(function (count, index) {
      if (count >= 2) activeColumns.push(index);
    });
    rows.forEach(function (count, index) {
      if (count >= 2) activeRows.push(index);
    });

    if (!activeColumns.length || !activeRows.length) return null;
    return {
      width: activeColumns[activeColumns.length - 1] - activeColumns[0] + 1,
      height: activeRows[activeRows.length - 1] - activeRows[0] + 1,
    };
  }

  function normaliseProduct(media, image, bounds) {
    if (!bounds || media.dataset.sidizMediaMode !== 'product') return;
    var mediaWidth = media.clientWidth;
    var mediaHeight = media.clientHeight;
    if (!mediaWidth || !mediaHeight || !image.naturalWidth || !image.naturalHeight) return;

    var fitScale = Math.min(mediaWidth / image.naturalWidth, mediaHeight / image.naturalHeight);
    var subjectWidth = ((bounds.width / MEDIA_SAMPLE_SIZE) * image.naturalWidth * fitScale) / mediaWidth;
    var subjectHeight = ((bounds.height / MEDIA_SAMPLE_SIZE) * image.naturalHeight * fitScale) / mediaHeight;
    var target = clamp(Number(media.dataset.sidizSubjectSize || 78) / 100, 0.6, 0.9);
    var scale = Math.min(target / subjectWidth, (target + 0.06) / subjectHeight);

    media.style.setProperty('--sidiz-media-scale', clamp(scale, 0.92, 1.55).toFixed(3));
  }

  function analyseMedia(media) {
    var image = media.querySelector('img');
    if (!image || !image.naturalWidth || !image.naturalHeight) return;

    try {
      var pixels = getImagePixels(image);
      var background = sampleBackground(pixels);
      media.style.setProperty('--sidiz-media-bg', 'rgb(' + background.join(', ') + ')');
      normaliseProduct(media, image, subjectBounds(pixels, background));
      media.dataset.sidizMediaAnalysed = 'true';
    } catch (error) {
      media.dataset.sidizMediaAnalysed = 'fallback';
    }
  }

  function bootMedia(scope) {
    var root = scope || document;
    var mediaItems = root.querySelectorAll('[data-sidiz-media-match]:not([data-sidiz-media-ready])');

    mediaItems.forEach(function (media) {
      var image = media.querySelector('img');
      media.dataset.sidizMediaReady = 'true';
      if (!image) return;
      if (image.complete) analyseMedia(media);
      else image.addEventListener('load', function () { analyseMedia(media); }, { once: true });
    });
  }

  function bootReveal(scope) {
    var root = scope || document;
    var items = root.querySelectorAll('[data-sidiz-reveal]:not([data-sidiz-reveal-ready])');
    if (!items.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.dataset.sidizRevealReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px 8% 0px', threshold: 0.01 }
    );

    items.forEach(function (item) {
      item.dataset.sidizRevealReady = 'true';
      if (item.closest('.sidiz-home-promotion__track, .sidiz-home-fit__track, .sidiz-trust__items, .sidiz-home-awards__track')) {
        item.classList.add('is-visible');
      } else {
        observer.observe(item);
      }
    });
  }

  function boot(scope) {
    bootReveal(scope);
    bootMedia(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
